import { render, staticRenderFns } from "./RecordView.vue?vue&type=template&id=09b5b16d&scoped=true&"
import script from "./RecordView.vue?vue&type=script&lang=ts&"
export * from "./RecordView.vue?vue&type=script&lang=ts&"
import style0 from "./RecordView.vue?vue&type=style&index=0&id=09b5b16d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5b16d",
  null
  
)

export default component.exports